import { ThemeProvider } from '@skoda/k2tools-app-components';
import { History } from 'history';
import * as React from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { ErrorBoundary } from './components/error-boundary';
import { ServicesProvider } from './components/servicesProvider';
import UnsupportedBrowser from './components/unsupported-browser-error';
import CarSelectorContext from './contexts/CarSelectorContext';
import OwnersManualsContext from './contexts/OwnersManualsContext';
import { ServicesCollection } from './contexts/servicesContext';
import VinContext from './contexts/VinContext';
import { DetailPage } from './pages/detail-page';
import { ErrorPage } from './pages/error-page';
import { HomePage } from './pages/home-page';
import './styles/global.scss';

interface OwnProps {
	history: History;
	services: ServicesCollection;
}

class Main extends React.Component<OwnProps> {
	render() {
		return (
			<React.Fragment>
				<ThemeProvider mode='light' theme='modern-solid'>
					<ServicesProvider services={this.props.services}>
						<Router history={this.props.history}>
							<ErrorBoundary resourceProvider={this.props.services.resourceProvider}>
								<OwnersManualsContext>
									<CarSelectorContext>
										<VinContext>
											<Switch>
												<Route path='/Models' component={HomePage} />
												<Route path='/Detail' component={DetailPage} />
												<Route path='/Error' component={ErrorPage} />
												<Route exact path='/' render={(props) => <Redirect to={'/Models' + props.location.search} />} />
												<Route>
													<Redirect to='/Error' />
												</Route>
											</Switch>
										</VinContext>
									</CarSelectorContext>
								</OwnersManualsContext>
							</ErrorBoundary>
							<UnsupportedBrowser />
						</Router>
					</ServicesProvider>
				</ThemeProvider>
			</React.Fragment>
		);
	}
}

export default Main;
